import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Grid, Typography, Link } from '@mui/material';

const OrderBookInfo = ({ orderInfo, project, isLink }) => {
  const linkUrl =
    orderInfo && orderInfo?.ordYn === 'Y'
      ? `/projectmng/${project?.prjUuid}/${project?.cmpGrade}/1`
      : `/chancemng/${project?.prjUuid}/${project?.cstGrade}/1`;

  const labelSx = { 
    fontWeight: 'bold', 
    color: '#000',
    whiteSpace: 'nowrap',
    fontSize: '0.82rem',
    width: '100px', 
    flexShrink: 0,
    mr: 2 
  };

  const valueSx = { 
    fontSize: '0.85rem',
    color: '#000',
  };

  const rowSx = {
    py: 0.8,
    borderBottom: '1px solid #eee',
    alignItems: 'center',
    display: 'flex',
  };

  const renderPrjNo = isLink ? (
    <Link 
      component={RouterLink} 
      to={linkUrl} 
      sx={{ 
        color: '#1976d2', 
        fontWeight: 'bold',
        textDecoration: 'none',
        fontSize: '0.85rem',
        '&:hover': { textDecoration: 'underline' } 
      }}
    >
      {orderInfo?.prjNo}
    </Link>
  ) : (
    <Typography sx={valueSx}>{orderInfo?.prjNo}</Typography>
  );

  return (
    <Box sx={{ px: 3, py: 0.5 }}>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>프로젝트명</Typography>
        <Box sx={{ flex: 1 }}>
          <Typography sx={{ ...valueSx, fontWeight: 500 }}>{orderInfo?.prjNm}</Typography>
        </Box>
      </Box>
      <Grid container sx={rowSx} columnSpacing={2}>
        <Grid item xs={2.4} sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography sx={labelSx}>매출처</Typography>
          <Typography sx={valueSx}>{orderInfo?.partnerNm}</Typography>
        </Grid>

        <Grid item xs={2.4} sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography sx={{ ...labelSx, width: '55px' }}>계약일</Typography>
          <Typography sx={valueSx}>{orderInfo?.expDay}</Typography>
        </Grid>
        
        <Grid item xs={2.4} sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography sx={{ ...labelSx, width: '80px' }}>계약완료일</Typography>
          <Typography sx={valueSx}>{orderInfo?.siDt}</Typography>
        </Grid>

        <Grid item xs={2.4} sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography sx={{ ...labelSx, width: '70px' }}>수금조건</Typography>
          <Typography sx={valueSx}>{orderInfo?.collCondt}</Typography>
        </Grid>

        <Grid item xs={2.4} sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography sx={{ ...labelSx, width: '70px' }}>지급조건</Typography>
          <Typography sx={valueSx}>{orderInfo?.payCondt}</Typography>
        </Grid>
      </Grid>
      {project?.prjTyp === 'N' && (
        <Box sx={rowSx}>
          <Typography sx={labelSx}>무상 유지보수</Typography>
          <Box sx={{ flex: 1 }}>
            <Typography sx={valueSx}>
              {orderInfo?.mtnFreeTm}개월 ({orderInfo?.mtnFreeStrtDt} ~ {orderInfo?.mtnFreeEndDt})
            </Typography>
          </Box>
        </Box>
      )}
      <Box sx={rowSx}>
        <Typography sx={labelSx}>프로젝트 번호</Typography>
        <Box sx={{ flex: 1 }}>
          {renderPrjNo}
        </Box>
      </Box>
      <Box sx={{ py: 1.0, display: 'flex', alignItems: 'flex-start' }}>
        <Typography sx={{ ...labelSx, mt: 0.3 }}>참고사항</Typography>
        <Box sx={{ flex: 1 }}>
          <Typography sx={{ ...valueSx, whiteSpace: 'pre-line', lineHeight: 1.4 }}>
            {orderInfo?.comment || '-'}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default OrderBookInfo;
